// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gi-3";
export var downloadButton = "_gi-4";
export var fileContainer = "_gi-9 _gi-7";
export var fileContainerBase = "_gi-7";
export var fileContainerBaseSm = "_gi-a _gi-7";
export var fileContainerFixedHeight = "_gi-8 _gi-7";
export var fileContainerFixedHeightSm = "_gi-c _gi-a _gi-7";
export var fileContainerSm = "_gi-b _gi-a _gi-7";
export var fileInfo = "_gi-5";
export var fileInfoWidthRestricted = "_gi-6";
export var fileType = "_gi-1";
export var fileTypeName = "_gi-2";
export var fileTypeSm = "_gi-d _gi-1";
export var image = "_gi-0";
export var link = "_gi-f";
export var overflowEllipsis = "_gi-e";